import { featureFlagSingleton } from '@warehouse/shared/infra';

export interface FeatureConfig {
	'top-bar-object-browser-button': boolean;
	'top-bar-profiles-button': boolean;
	'top-bar-editor-button': boolean;
	'top-bar-utilities-button': boolean;
	'top-bar-dashboard-button': boolean;
	'top-bar-admin-button': boolean;
	'top-bar-orders-button': boolean;
	'top-bar-inventory-button': boolean;
	'title-tracks-tab': boolean;
	'title-objects-tab': boolean;
	'title-artworks-tab': boolean;
	'title-orders-tab': boolean;
	'title-nx-tension-tab': boolean;
	'title-nx-orders-tab': boolean;
	'title-nx-inventory-tab': boolean;
	'title-activity-tabs': boolean;
	'title-report-export-button': boolean;
	'title-settings-export-mmc-xml-button': boolean;
	'object-browser-drawer-open-in-button': boolean;
	'object-browser-drawer-open-in-button-glim': boolean;
	'custom-field-localized-info-customBooleanField': boolean;
	'custom-field-localized-info-customFieldExample': boolean;
	'custom-field-localized-info-pullQuote': boolean;
	'custom-field-localized-info-staffDescription': boolean;
	'custom-field-basic-DRM': boolean;
	'custom-field-basic-materialStatus': boolean;
}

export type FeatureId =
	| 'top-bar-object-browser-button'
	| 'top-bar-profiles-button'
	| 'top-bar-editor-button'
	| 'top-bar-dashboard-button'
	| 'top-bar-utilities-button'
	| 'top-bar-admin-button'
	| 'top-bar-orders-button'
	| 'top-bar-inventory-button'
	| 'title-tracks-tab'
	| 'title-objects-tab'
	| 'title-artworks-tab'
	| 'title-orders-tab'
	| 'title-nx-tension-tab'
	| 'title-nx-orders-tab'
	| 'title-nx-inventory-tab'
	| 'title-activity-tabs'
	| 'title-report-export-button'
	| 'title-settings-export-mmc-xml-button'
	| 'object-browser-drawer-open-in-button'
	| 'object-browser-drawer-open-in-button-glim'
	| 'custom-field-localized-info-customBooleanField'
	| 'custom-field-localized-info-customFieldExample'
	| 'custom-field-localized-info-pullQuote'
	| 'custom-field-localized-info-staffDescription'
	| 'custom-field-basic-DRM'
	| 'custom-field-basic-materialStatus';

export function isFeatureEnabledForCurrentTenant(featureId: FeatureId) {
	const config = featureFlagSingleton.get().getConfig();
	return config[featureId];
}
